
// @group elements
export default {
  props: {
    to: {
      type: String,
      default: ''
    },
    isExternal: {
      type: Boolean,
      default: false
    },
    blank: {
      type: Boolean,
      default: null
    }
  }
};
